var map = {
	"./blogger.js": 3327,
	"./delicious.js": 1138,
	"./digg.js": 3681,
	"./evernote.js": 5935,
	"./linkedin.js": 9941,
	"./lj.js": 9767,
	"./messenger.js": 9095,
	"./moimir.js": 3118,
	"./odnoklassniki.js": 6578,
	"./pinterest.js": 7617,
	"./pocket.js": 6435,
	"./qzone.js": 8107,
	"./reddit.js": 3968,
	"./renren.js": 3189,
	"./sinaWeibo.js": 9111,
	"./skype.js": 2468,
	"./surfingbird.js": 4776,
	"./telegram.js": 75,
	"./tencentWeibo.js": 8175,
	"./tumblr.js": 7210,
	"./twitter.js": 3125,
	"./viber.js": 163,
	"./vkontakte.js": 8699,
	"./whatsapp.js": 7965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;